import { useBoolean, useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEvent } from '../../../Models/Event/IEvent';
import { IEventItem } from '../../../Models/Event/IEventItem';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { MyEventsView } from './MyEventsView';
import * as Services from '../../../Services/Services';
import { IEventApi } from '../../../Services/API/Event/IEventApi';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { RegistrationDetail } from '../../Registration/RegistrationDetail/RegistrationDetail';

interface IMyEventsProps {

}

export const MyEvents: React.FunctionComponent<IMyEventsProps> = (props) => {
    const [eventItemList, setEventItemList] = React.useState<IEventItem[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedEventId, setSelectedEventId] = React.useState<number>()

    const [isDeleteDialogOpened, setIsDeleteDialogOpened] = useBoolean(false);
    const [eventTypeToDelete, setEventTypeToDelete] = React.useState({ id: 0, desc: "" });

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventType = await eventTypeApi.getEventRegistredByUser();

        if (eventType.isSuccess && eventType.data) {
            setStatusMessage({ message: eventType.message, type: MessageBarType.success });
            setEventItemList(eventType.data);
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        loadData();
    }, [])

    

    const selectEvent = (item: IEventItem) => {
        setSelectedEventId(item.id);
        setIsPropertiesOpened.setTrue();
    }


    return (<>
        <MyEventsView selectItem={selectEvent} isLoading={isLoading} items={eventItemList} statusMessage={statusMessage}/>
        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
        {selectedEventId ?
            <RegistrationDetail
                eventId={selectedEventId}
                close={setIsPropertiesOpened.setFalse}
                isOpen={isPropertiesOpened}
                isAdmin={false}
            />
            : null
        }
    </>)
}

//{
//    selectedEvent ?
//        <EventProperties item={selectedEvent}
//            isOpen={isPropertiesOpened}
//            close={setIsPropertiesOpened.setFalse}
//            refresh={refresh}
//        /> : null
//}
